import {
  type Cell,
  type CellTemplate,
  type Compatible,
  type Span,
  type Uncertain,
} from '@silevis/reactgrid';
import * as React from 'react';

import { cn } from '@/lib/utils';

export type IconCellInterface = Cell &
  Span & {
    type: 'icon';
    iconSrc?: string;
    onIconClick?: () => void;
  };

class IconCell implements CellTemplate<IconCellInterface> {
  getCompatibleCell(uncertainCell: Uncertain<IconCellInterface>): Compatible<IconCellInterface> {
    return { ...uncertainCell, text: '', value: 0 };
  }

  isFocusable = (): boolean => false;

  getClassName(cell: Compatible<IconCellInterface>): string {
    return cell.className ? cell.className : '';
  }

  render(cell: Compatible<IconCellInterface>): React.ReactNode {
    return (
      <div
        onClick={cell?.onIconClick}
        className={cn(
          'flex w-full items-center justify-center [&_img]:size-4.5 [&_img]:cursor-pointer',
        )}
      >
        {cell?.iconSrc ? <img src={cell.iconSrc} /> : <></>}
      </div>
    );
  }
}

export default IconCell;
